export default {
  dashboard: {
    new_users: [],
    stats: {
      new_users: 0,
      revenue: 0,
    },
  },
}
